module.exports = __webpack_public_path__ + "static/Freight-BigLightItalic-03b4cb3417bb629e9d69968953a2deb7.ttf";